import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadDiscoveryTimelines, changeCurrentTab, fetchMore, initialFetchComplete } from 'shared/exploreActions';
import App from '../../components/explore/app';

const mapStateToProps = (state) => {
  const currentTab = state.explore.exploreTabs.currentTab;
  const isLoggedIn = state.explore.exploreTabs.isLoggedIn;
  const isFetching = state.explore.exploreTabs.isFetching;
  const loadingDiscoveryTimelines = state.explore.exploreTabs.loadingDiscoveryTimelines;
  const discoveryTimelines = state.explore.exploreTabs.discoveryTimelines;
  const feedItems = state.explore.exploreTabs.feedItems;
  const noMoreResults = state.explore.exploreTabs.noMoreResults;
  const adTag = state.explore.exploreTabs.adTag;
  const comScoreId = state.explore.exploreTabs.comScoreId;
  const isInitialFetchComplete = state.explore.exploreTimeline.isInitialFetchComplete;
  return {
    adTag,
    comScoreId,
    isLoggedIn,
    isFetching,
    isInitialFetchComplete,
    loadingDiscoveryTimelines,
    discoveryTimelines,
    currentTab,
    feedItems,
    noMoreResults,
  };
};

const matchDispatchToProps = (dispatch) => {
  return {
    onInitialFetchComplete: () => dispatch(initialFetchComplete()),
    onLoadDiscoveryTimelines: () => dispatch(loadDiscoveryTimelines()),
    onTabClick: tab => dispatch(changeCurrentTab(tab)),
    onExploreFeedScrollNearBottom: () => dispatch(fetchMore()),
  };
};

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(App));
